"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = void 0;
var minigolfScene_create_sidecar_1 = require("./minigolfScene_create-sidecar");
var minigolfScene_update_sidecar_1 = require("./minigolfScene_update-sidecar");
var create = function () {
    minigolfScene_create_sidecar_1.minigolfScene_create.create();
};
exports.create = create;
var update = function (time, delta) {
    minigolfScene_update_sidecar_1.minigolfScene_update.update(time, delta);
};
exports.update = update;
